export class AppConfiguration {
  serverApiUrl: string;
  flexmonsterLicenseKey: string;
  websocket: {
    url: string;
  };
}
